import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import React from "react";
import { ConfirmationModificationMessage } from "./ConfirmationModificationMessage";
import { ConfirmationAssociationModal } from "./ConfirmationAssociationModal";
import AdvancedDisplayNameModal from "@pages/SettingGeneral/DisplayName/AdvancedDisplayNameModal";

type ModalsContainerTypes = {
    setDataIsUpdated: Function;
    setDataSale: Function;
    setIsEdited: Function;
    isModalOpen: any;
    associated: any;
    salesSupport: any;
    dataSale: any;
    setLimit: Function;
    isModalModifiedOpened: any;
    formState: any;
    tagsData: any;
    setTagsData: Function;
    i18nextLng: any;
    isConsult: any;
    isAdvancedDisplayNameModalOpen: any;
    setIsAdvancedDisplayNameModalOpen: Function;
    handleSetAdvancedDisplayName: any;
    language: any;
    isActionsClicked: any;
    setActions: Function;
    setIsActionsClicked: Function;
    setIsModalOpen: Function;
    setIsModalModifiedOpened: Function;
    setModalState: Function;
    modalState: any;
    tags: any;
    setSalesSupport: any;
    setState: any;
};
const ModalsContainer = ({
    setDataIsUpdated,
    setDataSale,
    setIsEdited,
    isModalOpen,
    associated,
    salesSupport,
    dataSale,
    setLimit,
    isModalModifiedOpened,
    formState,
    tagsData,
    setTagsData,
    i18nextLng,
    isConsult,
    isAdvancedDisplayNameModalOpen,
    setIsAdvancedDisplayNameModalOpen,
    handleSetAdvancedDisplayName,
    language,
    isActionsClicked,
    setActions,
    setIsActionsClicked,
    setIsModalOpen,
    setIsModalModifiedOpened,
    setModalState,
    modalState,
    tags,
    setSalesSupport,
    setState,
}: ModalsContainerTypes) => {
    return (
        <>
            {modalState.isModalOpened && (
                <ConfirmationEditMessage
                    isModalOpened={modalState.isModalOpened}
                    setIsModalOpened={setModalState((value: any) => ({
                        ...modalState,
                        isModalOpened: value,
                    }))}
                    setIsAddClicked={setModalState((value: any) => ({
                        ...modalState,
                        isAddModeOfSaleClicked: value,
                    }))}
                    setEditedData={setDataSale}
                    setIsEdited={setIsEdited}
                />
            )}

            {isModalOpen && (
                <ConfirmationModificationMessage
                    isModalOpened={isModalOpen}
                    setIsModalOpened={setIsModalOpen}
                    setIsEdited={setIsEdited}
                    setDataIsUpdated={setDataIsUpdated}
                    associated={[dataSale, ...associated]}
                    setModalState={setModalState}
                    salesSupport={salesSupport}
                    dataSale={dataSale}
                    setLimit={setLimit}
                    tags={tags}
                    setSalesSupport={setSalesSupport}
                    setState={setState}
                />
            )}

            {isModalModifiedOpened && (
                <ConfirmationAssociationModal
                    isModalOpened={isModalModifiedOpened}
                    setIsModalOpened={setIsModalModifiedOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    data={{
                        saleMode: formState.saleMode,
                        displayName:
                            formState.advancedDisplayName.languages[i18nextLng],
                        salesSupport: salesSupport,
                        tag: tagsData,
                        advancedDisplayName: formState.advancedDisplayName,
                    }}
                    setDataSale={setDataSale}
                    setTagsData={setTagsData}
                    tags={tags}
                    setIsEdited={setIsEdited}
                />
            )}

            {isAdvancedDisplayNameModalOpen && (
                <AdvancedDisplayNameModal
                    isConsult={isConsult}
                    isAdvancedDisplayNameModalOpen={
                        isAdvancedDisplayNameModalOpen
                    }
                    setIsAdvancedDisplayNameModalOpen={
                        setIsAdvancedDisplayNameModalOpen
                    }
                    setAdvancedDisplayName={handleSetAdvancedDisplayName}
                    displayName={formState.advancedDisplayName}
                    language={language}
                    isActionsClicked={isActionsClicked}
                    setActions={setActions}
                    setIsActionsClicked={setIsActionsClicked}
                    setIsEdited={setIsEdited}
                />
            )}
        </>
    );
};

export default ModalsContainer;
